<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Calibration Technician Information '{{innerPersonRecord.fullname}}'</h5>
      <form [formGroup]="EditExpertCalibration" (submit)="SubmitAddNewExpertCalibration()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Activity Location  </label>
            <select formControlName="Area_Type" class="custom-select">
              <option value="0">Select</option>
              <option value="1">Inside the Laboratory</option>
              <option value="2">Outside the Laboratory</option>
              <option value="3">Inside/Outside the Laboratory</option>
            </select>
          </div>
          <div class="form-group col-md-4" style="visibility: hidden;">
            <label for="exampleInputEmail1">Responsibility</label>
            <input formControlName="Response" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Response().valid && get_Form_Response().touched" class="form-text text-muted MyErrorRedColor">Enter the responsibility.</small>
          </div>
          <div class="form-group col-md-4" style="visibility: hidden;">
            <label for="exampleInputEmail1">Description</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
          </div>
        </div>

          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!EditExpertCalibration.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
          <button (click)="OnSet_Expert_Calibration()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

